module.exports = __webpack_public_path__ + "img/logo_text.4b7c8af6.png";